/* eslint-disable max-classes-per-file */
import { Expose, Type } from "class-transformer";

import { BaseModel } from "src/shared/models/base.model";
import { DocumentsTreeClaimDetail } from "src/containers/household-claim/models/document-tree-detail.model";
import { DocumentsTreeClaimDetailItem } from "src/containers/household-claim/models/documents-tree-item.model";
import { DocumentsTreeNoDeclaredStuff } from "src/containers/household-claim/models/documents-tree-no-declared-stuff.model";

export class HouseholdClaimDocumentsTree extends BaseModel {
    @Expose() label = "";
    @Expose()
    @Type(() => DocumentsTreeClaimDetail)
    claimDetailDocuments?: DocumentsTreeClaimDetail;

    @Expose()
    @Type(() => DocumentsTreeNoDeclaredStuff)
    noDeclaredStuff?: DocumentsTreeNoDeclaredStuff;

    @Expose()
    @Type(() => DocumentsTreeClaimDetailItem)
    items: DocumentsTreeClaimDetailItem[] = [];
}
